const product_page = () => {
    const product_overview = $('.js-product-overview');
    let overview_image = product_overview.children('img');
    let overview_width = product_overview.width();
    let image_width = overview_image.width();
    let percent = (image_width / overview_width) * 100;
    let supportsTouch = false;
    let $configurations = $('.js-configuration-wrap');
    let $materials_container = $('.js-materials-parent-container');

    function get_module_start_price (that, product_id, module_index, default_price = 0){
        jQuery.post( ajaxurl, { action: "get_modules_start_price", product_id: "123" }, "text" )
          .done(function( data ) {
            console.debug( "Data Loaded: " + data );
          });
    } 
    $('.product-modules .p-module__item').each(function(index, item){
        let loader = $(this).find('.js-ajax-loader');
        let data = {
            action: "get_modules_start_price", 
            product_id: loader.attr('data-product-id'), 
            module_index: loader.attr('data-index'), 
            default_price: loader.attr('data-default-price')
        };
        jQuery.post( ajaxurl, data )
          .done(function( data ) {
            loader.html(data);
            // console.debug( "Data Loaded: " + data );
          });
    })

    if($configurations.length > 0) {
        $configurations.css('width', 100/$configurations.length + '%');
    }

    if(percent < 85) {
        overview_image.addClass('centered');
    }

    if ('ontouchstart' in window || window.navigator.msPointerEnabled || 'ontouchstart' in document.documentElement){

        supportsTouch = true;

    }

    if(!supportsTouch) {
        events = {
            click: 'mousedown',
        }
    }
    else {
        events = {
            click: 'touchstart',
        }
    }

    const $model = $('.p-model');
    const $trigger = $model.find('.wave');

    let i = 1;

    let dots_interval = setInterval(interval_func, 3000);
    let clicked_dot = false;

    $trigger
        .mouseenter(function() {

            clearInterval(dots_interval);
            clicked_dot = false;

            $(this).trigger(events.click);

            $trigger.on('click', function () {
                clicked_dot = true;
            })
        })
        .mouseleave( function() {

            if(!clicked_dot) {
                dots_interval = setInterval(interval_func, 3000);
            }

        });

    resizeModelWrap();

    function interval_func() {

        $trigger.eq(i).trigger(events.click);

        if(i >= $trigger.length - 1) {
            i = 0;
        }
        else {
            i++;
        }

    }

    $('.no-image-alert .close').on('click', function () {
        $('.no-image-alert').hide();
    });

    if($(window).width() < 576) {

        let $pr_params = $('.product-constructor__params').detach();

        $materials_container.after($pr_params);

        $('.js-configurations-accordion-title').on('click touch', function () {
            
            let parent = $(this).parents('.js-configurations-accordion');
            let ths_body = parent.find('.js-configurations-accordion-body');
            let all_bodies = $('.js-configurations-accordion-body');

            if(parent.hasClass('active')) {
                ths_body.slideUp();
                parent.removeClass('active');
            }
            else {
                ths_body.slideDown().addClass('slided');
                parent.addClass('active');
            }

            all_bodies.each(function () {
                let el = $(this);
                if(!el.hasClass('slided')) {
                    el.slideUp();
                    el.parents('.js-configurations-accordion').removeClass('active');
                }
            });

            all_bodies.removeClass('slided');

        })
    }

    function add_shades() {
        const product_overview = $('.js-product-overview');
        let overview_image = product_overview.children('img');
        let overview_image_ovelay = product_overview.find('.js-img-overlay');

        let img_w = overview_image.width();
        let img_h = overview_image.height();

        let interval = setInterval(function () {

            if(overview_image_ovelay.hasClass('ready')){
                clearInterval(interval);
            }
            else {
                overview_image_ovelay.css({
                    'width' : (img_w + 5) + 'px',
                    'height' : (img_h  + 2) + 'px'
                }).addClass('ready');
            }

        });


        $(window).resize(function () {
            let img_w = overview_image.width();
            let img_h = overview_image.height();

            overview_image_ovelay.css({
                'width' : (img_w + 5) + 'px',
                'height' : (img_h  + 2) + 'px'
            });
        });
    }

    function resizeModelWrap() {
        let $wrap = $('.p-model__image-wrap');

        let img = $wrap.find('>img');

        img.on('load', function () {
            let img_w = img.width();
            let img_h = img.height();

            $wrap.css({
                'width' : img_w + 'px',
                'height' : img_h + 'px'
            })
        })
    }
};


if($('.js-product-single').length > 0 || $('.js-model-page-single').length > 0) {

    $(document).ready(function () {
        product_page();
    });

}